import { useSessionStorage } from '@vueuse/core'

import type { Ref } from 'vue'

interface CanonicalRouteOptions {
  key: string
}

interface CanonicalRouteReturn {
  canonicalUrl: Ref<string | null>
  saveCanonicalUrl: () => void
}

export const useCanonicalRoute = ({ key }: CanonicalRouteOptions): CanonicalRouteReturn => {
  const canonicalUrl = useSessionStorage<string | null>(key, null)

  const saveCanonicalUrl = (): void => {
    const route = useRoute()

    canonicalUrl.value = route.fullPath
  }

  return {
    canonicalUrl,
    saveCanonicalUrl,
  }
}
